module.exports = __webpack_public_path__ + "5f24eebff66724721fa11a2012395db2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/barbell.png
// module id = 2820
// module chunks = 0